import React from 'react';
import {
  Edit,
  SimpleForm,
  TextInput,
  required,
  useNotify,
  useRedirect,
  useRecordContext,
} from 'react-admin';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { Business as BusinessIcon } from '@mui/icons-material';
import ResourceBreadcrumbsWithActions from '../../components/ResourceBreadcrumbsWithActions';

const EnterpriseEditContent = () => {
  const record = useRecordContext();
  const notify = useNotify();
  const redirect = useRedirect();

  const onSuccess = (data: any) => {
    notify('Enterprise updated successfully', { type: 'success' });
    redirect(`/enterprises/${data.id}/show`);
  };

  return (
    <Card sx={{ maxWidth: 800, mx: 'auto', mt: 3 }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
          <BusinessIcon color="primary" sx={{ fontSize: 32 }} />
          <Typography variant="h5" sx={{ fontWeight: 600 }}>
            Edit Enterprise: {record?.name}
          </Typography>
        </Box>

        <SimpleForm toolbar={<Box />}>
          <TextInput
            source="name"
            label="Enterprise Name"
            validate={[required()]}
            fullWidth
            helperText="The name of your enterprise organization"
          />

          <TextInput
            source="description"
            label="Description"
            multiline
            rows={3}
            fullWidth
            helperText="Brief description of the enterprise (optional)"
          />

          <TextInput
            source="logoUrl"
            label="Logo URL"
            fullWidth
            helperText="URL to the enterprise logo image (optional)"
          />
        </SimpleForm>
      </CardContent>
    </Card>
  );
};

const EnterpriseTitle = () => {
  const record = useRecordContext();
  if (!record) return 'Edit Enterprise';
  return `Edit ${record.name}`;
};

export const EnterpriseEdit = () => (
  <Edit
    actions={false}
    title={<EnterpriseTitle />}
    mutationMode="pessimistic"
  >
    <ResourceBreadcrumbsWithActions hideEdit={true} hideDelete={false} />
    <EnterpriseEditContent />
  </Edit>
);
